<template>
  <div id="app">
    <transition name='fade'>
      <router-view v-if="isRouterAlive"></router-view>
    </transition>
  </div>
</template>

<script>
import userAPI from '@/api/user';

export default {
  name: 'App',
  /**
     * 提供了页面强制刷新的方法，用于处理组件未重新渲染而导致的bug
     * 使用方法：在需要使用的组件的export default里注入依赖：inject: ['reload']
     * 并在方法中通过this.reload()进行调用
     * Author:SUN HAO
     * Date:2019.3.3
     */

  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  mounted() {
    // window.addEventListener('beforeunload', e => this.set());
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
};


</script>

<style lang='scss'>
  @import './style/reset.scss';
  @import './style/common.scss';
  @import './style/media.scss';

  #app {
    width: 100%;
    height: 100%;
    overflow: hidden;
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .25s;

  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }
</style>



// WEBPACK FOOTER //
// src/App.vue